import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  HeartPulse,
  CalendarHeart,
  Baby,
  User,
  Droplet,
  CalendarDays,
  FileText,
  BookOpen,
  Sparkles,
  Wrench,
  Tag,
  CreditCard,
  ShoppingBag,
  MoreHorizontal
} from "lucide-react";
import { ROUTES } from "../routes/paths";
import "../styles/bottom-nav.css";

const items = [
  { key: "dashboard", label: "Home", Icon: Home, path: ROUTES.DASHBOARD },
  { key: "health", label: "Health", Icon: HeartPulse, path: ROUTES.HEALTH },
  { key: "pregnancy", label: "Pregnancy", Icon: CalendarHeart, path: ROUTES.PREGNANCY },
  { key: "baby", label: "Baby", Icon: Baby, path: ROUTES.BABY },
  { key: "store", label: "Store", Icon: ShoppingBag, path: ROUTES.STORE }
];

const MORE_ITEMS = [
  { key: "profile", label: "Profile", Icon: User, path: ROUTES.PROFILE },
  { key: "period", label: "Period & ovulation", Icon: Droplet, path: ROUTES.PERIOD },
  { key: "appointments", label: "Appointments", Icon: CalendarDays, path: ROUTES.APPOINTMENTS },
  { key: "reports", label: "Reports", Icon: FileText, path: ROUTES.REPORTS },
  { key: "articles", label: "Articles", Icon: BookOpen, path: ROUTES.ARTICLES },
  { key: "wellness", label: "Daily Check‑in", Icon: Sparkles, path: ROUTES.WELLNESS },
  { key: "tools", label: "Tools", Icon: Wrench, path: ROUTES.TOOLS },
  { key: "baby-names", label: "Baby Names", Icon: Tag, path: ROUTES.BABY_NAMES },
  { key: "subscription", label: "Subscription", Icon: CreditCard, path: ROUTES.SUBSCRIPTION }
];

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  // Hide on auth pages and admin routes; Layout already guards these but we keep it defensive
  if (location.pathname === ROUTES.HOME || location.pathname === ROUTES.REGISTER) return null;
  if (location.pathname.startsWith(ROUTES.ADMIN)) return null;

  const moreActive = MORE_ITEMS.some((item) => location.pathname.startsWith(item.path));

  const goTo = (path) => {
    setMoreOpen(false);
    navigate(path);
  };

  return (
    <>
      {moreOpen && (
        <div className="mkc-bottom-nav-sheet-overlay" onClick={() => setMoreOpen(false)} aria-hidden="true" />
      )}
      {moreOpen && (
        <div className="mkc-bottom-nav-sheet" role="dialog" aria-label="More sections">
          {MORE_ITEMS.map((item) => (
            <button
              key={item.key}
              type="button"
              className="mkc-bottom-nav-sheet-item"
              onClick={() => goTo(item.path)}
            >
              <span className="mkc-bottom-nav-icon" aria-hidden="true">
                <item.Icon size={20} strokeWidth={1.75} />
              </span>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
      <nav className="mkc-bottom-nav" aria-label="Primary">
        {items.map((item) => {
          const active = location.pathname.startsWith(item.path);
          return (
            <button
              key={item.key}
              type="button"
              className={`mkc-bottom-nav-item ${active ? "mkc-bottom-nav-item-active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              <span className="mkc-bottom-nav-icon" aria-hidden="true">
                <item.Icon size={20} strokeWidth={1.75} />
              </span>
              <span className="mkc-bottom-nav-label">{item.label}</span>
            </button>
          );
        })}
        <button
          type="button"
          className={`mkc-bottom-nav-item ${moreActive ? "mkc-bottom-nav-item-active" : ""}`}
          aria-haspopup="dialog"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen((o) => !o)}
        >
          <span className="mkc-bottom-nav-icon" aria-hidden="true">
            <MoreHorizontal size={20} strokeWidth={1.75} />
          </span>
          <span className="mkc-bottom-nav-label">More</span>
        </button>
      </nav>
    </>
  );
};

export default BottomNav;
